import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/AdvanceSearchSlice';

const selectDomain = (state: RootState) => state?.advanceSearch || initialState;

export const selectAdvanceSearchLoading = createSelector(
  [selectDomain],
  (state) => state.isLoading,
);

export const selectAdvanceSearchLoaded = createSelector(
  [selectDomain],
  (state) => state.isLoaded,
);

export const selectAdvanceSearchIsPagination = createSelector(
  [selectDomain],
  (state) => state.isPagination,
);

export const selectAdvanceSearchPersonExtendedLoading = createSelector(
  [selectDomain],
  (state) => state.isPersonExtendedLoading,
);

export const selectAdvanceSearchPersonExtendedLoaded = createSelector(
  [selectDomain],
  (state) => state.isPersonExtendedLoaded,
);

export const selectAdvanceSearchType = createSelector(
  [selectDomain],
  (state) => state.searchType,
);

export const selectAdvanceSearchParams = createSelector(
  [selectDomain],
  (state) => state.searchParams,
);

export const selectAdvanceSearchPeopleSection = createSelector(
  [selectDomain],
  (state) => state.peopleSection,
);

export const selectAdvanceSearchCompaniesSection = createSelector(
  [selectDomain],
  (state) => state.companiesSection,
);

export const selectAdvanceSearchBuyerGroupsSection = createSelector(
  [selectDomain],
  (state) => state.buyerGroupsSection,
);

export const selectAdvanceSearchMemberOptions = createSelector(
  [selectDomain],
  (state) => state.memberOptions,
);

export const selectAdvanceSearchMemberLoading = createSelector(
  [selectDomain],
  (state) => state.memberLoading,
);

export const selectAdvanceSearchMemberHasMore = createSelector(
  [selectDomain],
  (state) => state.memberHasMore,
);

export const selectAdvanceSearchMemberOffset = createSelector(
  [selectDomain],
  (state) => state.memberOffset,
);

export const selectAdvanceSearchMemberOptionsLoaded = createSelector(
  [selectDomain],
  (state) => state.memberOptionsLoaded,
);

export const selectAdvanceSearchMemberTotal = createSelector(
  [selectDomain],
  (state) => state.memberTotal,
);

export const selectAdvanceSearchSharedByOptions = createSelector(
  [selectDomain],
  (state) => state.sharedByOptions,
);

export const selectAdvanceSearchSharedByLoading = createSelector(
  [selectDomain],
  (state) => state.sharedByLoading,
);

export const selectAdvanceSearchSharedByHasMore = createSelector(
  [selectDomain],
  (state) => state.sharedByHasMore,
);

export const selectAdvanceSearchSharedByPage = createSelector(
  [selectDomain],
  (state) => state.sharedByPage,
);

export const selectAdvanceSearchSharedByOptionsLoaded = createSelector(
  [selectDomain],
  (state) => state.sharedByOptionsLoaded,
);

export const selectAdvanceSearchSharedByTotal = createSelector(
  [selectDomain],
  (state) => state.sharedByTotal,
);

export const selectAdvanceSearchMemberSearchTerm = createSelector(
  [selectDomain],
  (state) => state.memberSearchTerm,
);

export const selectAdvanceSearchSharedBySearchTerm = createSelector(
  [selectDomain],
  (state) => state.sharedBySearchTerm,
);

export const selectAdvanceSearchPeopleForm = createSelector(
  [selectDomain],
  (state) => state.peopleForm,
);

export const selectAdvanceSearchCompanyForm = createSelector(
  [selectDomain],
  (state) => state.companyForm,
);

export const selectAdvanceSearchBrmForm = createSelector(
  [selectDomain],
  (state) => state.brmForm,
);

export const selectAdvanceSearchMetadataLoading = createSelector(
  [selectDomain],
  (state) => state.advanceSearchMetadataLoading,
);

export const selectAdvanceSearchMetadata = createSelector(
  [selectDomain],
  (state) => state.advanceSearchMetadata,
);

export const selectAdvanceSearchActiveTab = createSelector(
  [selectDomain],
  (state) => state.activeTab,
);
